import { useEffect, useState } from 'react';
import { isValidLatLong } from '@/utilities/latlong';

export function useGeoLocation() {
  // gesture elott nem lehet location-t kerni
  const [gesture, setGesture] = useState<boolean>(false);
  const [location, setLocation] = useState<[number, number] | undefined>();

  useEffect(() => {
    let watchID: number;

    function cleanup() {
      document.removeEventListener('click', listener, { capture: true });
      document.removeEventListener('mouseup', listener, { capture: true });
      navigator.geolocation.clearWatch(watchID);
    }

    function listener() {
      setGesture(true);
      cleanup();
    }

    if (!gesture) {
      // FIXME mobile-on mi jon ??? pointerup touchend ?
      document.addEventListener('click', listener, { capture: true });
      document.addEventListener('mouseup', listener, { capture: true });
    }

    if (gesture && 'geolocation' in navigator) {
      watchID = navigator.geolocation.watchPosition((position) => {
        if (isValidLatLong(position.coords)) {
          setLocation([position.coords.latitude, position.coords.longitude]);
        }
      });

      return () => cleanup();
    }
  }, [gesture]);

  return location;
}
